// MpfCheckboxes.props.ts
import type { HeadingLevel } from '../MpfInput/MpfInputBaseProps';
import { HeadingLevelSize, MpfInputBaseProps } from '../MpfInput/MpfInputBaseProps';

export interface MpfCheckboxDividerItem {
  type: 'divider';
  text: string;
}

export interface MpfCheckboxOptionItem {
  type?: 'checkbox';
  value: string | number | null;
  label: string;
  id?: string;
  hint?: string;
  srHint?: string;
  hintSecond?: string;
  srHintSecond?: string;
  disabled?: boolean;
}

export type MpfCheckboxItem = MpfCheckboxDividerItem | MpfCheckboxOptionItem;

export interface MpfCheckboxesProps extends Omit<
  MpfInputBaseProps,
  'headingLevelSize' | 'headingLevel' | 'modelValue' | 'initialValue'
> {
  type?: 'checkboxes';
  errors?: string[];
  initialValue?: (string | number | null)[];
  items: MpfCheckboxItem[];
  legend?: string;
  legendHeadingLevel?: HeadingLevel;
  legendHeadingSize?: HeadingLevelSize;
  modelValue: null | (string | number | null)[];
}

export const mpfCheckboxesDefaults = {
  modelValue: null,
  type: 'checkboxes',
  // @ts-expect-error
  errors: () => [] as string[],
} satisfies Partial<MpfCheckboxesProps>;

export type MpfCheckboxesEmits = {
  (e: 'update:modelValue', value: (string | number | null)[]): void;
  (e: 'change', value: (string | number | null)[] | any[], event: Event): void;
  (e: 'blur', event: FocusEvent): void;
};
